module.exports = __webpack_public_path__ + "img/2.6c76ae4f.png";